import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';
import { getBackendDomain } from './common';
import DomMessage from './messageOnce';

const BASE_PREFIX = process.env.REACT_APP_BASE_PREFIX;

export const toLoigin = () => {
  setTimeout(() => {
    sessionStorage.removeItem('USER_BASE_INFO');
    if (!window.location.pathname.includes('/login')) {
      window.location.href = BASE_PREFIX !== '/' ? `${BASE_PREFIX}/login` : '/login';
    }
  }, 1000);
};

export const AuthExpiredCodes = [
  '002007',
  '002004',
  '002005',
  '002006',
  '792100',
  '792106',
  '792109',
];

export const headers = () => {
  // const { getItem } = sessionStorage;
  // TODO: 对应项目实际header配置
  const platformRole = process.env.REACT_APP_PLATFORM_ROLE;
  console.log('platformRole', platformRole);
  return {
    // 'sc-id': `web-${uuidv4()}`,
    'saas-source': platformRole === 'SUPPLIER' ? 'COS_SUPPLIER' : 'COS_ADMIN',
    'Cache-Control': 'no-cache',
    'x-forwarded-host': '127.0.0.1',
  };
};

const request = axios.create({
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'comma' }),
});
const messageOnce = new DomMessage();

/**
 * 请求拦截功能配置
 * 1. 统一添加请求头headers
 */
request.interceptors.request.use(
  (config) => {
    const platformRole = process.env.REACT_APP_PLATFORM_ROLE;
    config.headers['saas-source'] = platformRole === 'SUPPLIER' ? 'COS_SUPPLIER' : 'COS_ADMIN';
    config.headers['Cache-Control'] = 'no-cache';
    config.headers['x-forwarded-host'] = '127.0.0.1';
    config.headers['sc-domain'] = getBackendDomain();
    // config.params = {
    //   T: Date.now(),
    //   ...config.params,
    // };

    return config;
  },
  (error) => {
    console.log(error);

    // Do something with request error
    messageOnce.error(error);
    Promise.reject(error);
    return;
  },
);

/**
 * 相应拦截功能配置
 * 1. 统一处理后端报错码code
 * 2. 统一处理特殊的状态码，如用户未登录/登陆过期
 * 3. 统一出http状态码异常情况
 * 4. 返回后端data数据
 */
request.interceptors.response.use(
  (response) => {
    const token = response.headers['cos-admin'];
    if (token) {
      sessionStorage.setItem('adminToken', token);
    }
    const res = response.data || {};
    // 如果有这个参数，就返回完整的response
    if ((response.config as any).__ALL_DATA__) return response;
    if (res.data) return res.data;
    return res;
  },
  (error) => {
    console.log('error', error);
    // 针对 Blob 类型错误处理
    if (error?.response?.data instanceof Blob) {
      const res = error.response;
      const fileReader: any = new FileReader();
      fileReader.readAsText(new Blob([res.data], { type: 'application/octet-stream' }), 'utf-8');
      fileReader.onload = () => {
        const { message, code } = JSON.parse(fileReader.result);
        if (code !== '793191') {
          messageOnce.error(message);
        }
      };
      return Promise.reject(error);
    }
    // 后端把详细错误放在 data（字符串）时优先展示，否则回退到 message
    const errorData = error?.response?.data?.data;
    const errorMessage =
      (typeof errorData === 'string' && errorData) || error?.response?.data?.message;
    const errorCode = error?.response?.data?.code;

    const INACTIVITY =
      error?.request?.responseURL?.includes?.('__INACTIVITY__') ||
      error?.config?.data?.includes?.('__INACTIVITY__');

    const AGENT_IMPORT = error?.request?.responseURL?.includes?.(
      'api/car/admin/agent/order/import',
    );
    if (INACTIVITY || AGENT_IMPORT) {
      return Promise.reject(error);
    }
    //登录失效提醒
    if (error?.response?.status === 401) {
      if (AuthExpiredCodes.includes(errorCode)) {
        messageOnce.error('登录失效，请重新登录');
        toLoigin();
      } else {
        messageOnce.error(errorMessage);
        return Promise.reject(error);
      }
      return Promise.reject(error);
    }

    // 服务器错误码处理
    if ([500, 504].includes(error?.response?.status)) {
      messageOnce.error('网络异常，请稍后再试');
      return Promise.reject(error);
    }

    messageOnce.error(errorMessage || String(error.message) || '网络异常，请稍后再试');
    return Promise.reject(error);
  },
);

export interface Request {
  getUri(config?: AxiosRequestConfig): string;
  request<T = any, D = any>(config: AxiosRequestConfig<D>): Promise<T>;
  get<T = any, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<T>;
  delete<T = any, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<T>;
  head<T = any, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<T>;
  options<T = any, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<T>;
  post<T = any, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<T>;
  put<T = any, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<T>;
  patch<T = any, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<T>;
  postForm<T = any, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<T>;
  putForm<T = any, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<T>;
  patchForm<T = any, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<T>;
}

export default request as Request;
